export const imageCodes = {
    
    cate1: {
        code: "${merchantId}_tmpl_img_14",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat1.jpg?alt=media&token=146ee586-051f-4a8a-8471-2daa889affc5"
    },

    cate2: {
        code: "${merchantId}_tmpl_img_15",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcat3.jpg?alt=media&token=7b8b38fd-b93c-45f7-a176-43f49bd1440c"
    },

    cate3: {
        code: "${merchantId}_tmpl_img_16",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcatbean.jpg?alt=media&token=3e52f369-1db5-4c9b-8217-6915756e3e30"
    },

    cate4: {
        code: "${merchantId}_tmpl_img_17",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fcatrice.jpg?alt=media&token=97363825-895b-43aa-9b20-a09a2718b88f"
    },

    cate5: {
        code: "${merchantId}_tmpl_img_18",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fgreentea.jpg?alt=media&token=5c2bf24f-bedc-41b5-9f08-aa1d828a1a8e"
    },

    cate6: {
        code: "${merchantId}_tmpl_img_19",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fsnack.jpg?alt=media&token=6fbd2569-0721-4d0b-a848-3fe615e94a4c"
    },

    packaging: {
        code: "${merchantId}_tmpl_img_10",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fpackaging.jpg?alt=media&token=9bdb4bd8-ee75-457f-971e-b0f185b5f783"
    },

    local: {
        code: "${merchantId}_tmpl_img_4",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Flocal.jpg?alt=media&token=e7666729-7989-41f0-b278-0d66c29bbc04"
    },

    promoBanner: {
        code: "${merchantId}_tmpl_img_5",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fsar%20ban%20lat1.png?alt=media&token=43b45606-7626-46cc-aa4f-97569cb54f65"
    },

    delivery: {
        code: "${merchantId}_tmpl_img_6",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fdelivery.jpg?alt=media&token=e98dda55-9b27-4b95-bbb2-3b0b73bc22ae"
    },

    localBagyi: {
        code: "${merchantId}_tmpl_img_7",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FlocalBagyi.jpg?alt=media&token=810a7870-621a-4a4b-a79c-1385da2bb6db"
    },

    localRice: {
        code: "${merchantId}_tmpl_img_12",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F16522538380188252226e2793a931026b59e61067444f_tiny.jpg?alt=media&token=00d5325e-55e7-4814-ba79-b9f1d937ecea"
    },

    localEgg: {
        code: "${merchantId}_tmpl_img_11",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fabe.jpg?alt=media&token=ae315fd7-9611-4991-820d-766156f926ca"
    },

    localOil: {
        code: "${merchantId}_tmpl_img_13",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FlocalNoodle.jpg?alt=media&token=a8ff3a17-d1a2-403c-bcad-b660f003a3df"
    },

    localTea: {
        code: "${merchantId}_tmpl_img_20",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FlocalTea.jpg?alt=media&token=2f411d42-583a-448b-b542-bcc4c09daf82"
    },

    localBeann: {
        code: "${merchantId}_tmpl_img_21",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F1655568752915909a148013b3e87b8089b24885fa5d95_tiny.jpg?alt=media&token=3a15cf64-c42e-4fa2-ae6d-60352ede09f2"
    },

    homeSlider: {
        code: "${merchantId}_tmpl_img_22",
        image: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2Fhome_slider.png?alt=media&token=429860b1-970f-46eb-8809-b8c08d3f4785"
    },
    

}

export const titleCodes = {
    
    category: {
        code: "${merchantId}_tmpl_title_1",
        title: "Brought to you by စားဖိုဆောင်"
    },

    localProducts: {
        code: "${merchantId}_tmpl_title_2",
        title: "Local Products"
    },


    packaging: {
        code: "${merchantId}_tmpl_title_3",
        title: "ထုတ်ပိုးမှုပုံစံ"
    },

    delivery: {
        code: "${merchantId}_tmpl_title_4",
        title: "ပို့ဆောင်မှု"
    },

    contact: {
        code: "${merchantId}_tmpl_title_12",
        title: "ပစ္စည်းမှန် စျေးတန် စေတနာထက်သန် တဲ့ စားဖိုဆောင် ကို သတိရလိုက်ပါ"
    }
}


export const textCodes = {
    
    downloadApp: {
        code: "${merchantId}_tmpl_text_37",
        text: "d o w n l o a d a p p"
    },

    shopNow: {
        code: "${merchantId}_tmpl_text_36",
        text: "s h o p n o w"
    },

    deliText: {
        code: "${merchantId}_tmpl_text_35",
        text: "စားဖိုဆောင် မှ တစ်သိန်းကျပ်နှင့် အထက် အော်ဒါများကို Free Delivery ပို့ဆောင်ပေးပါတယ်ရှင်။ ဒါ့အပြင် ရန်ကုန်မြို့တွင်းမှ မှာယူမှုများအတွက်လည်း free delivery ပို့ဆောင်ပေးပါတယ်ရှင်။ Delivery ပို့တဲ့အခါမှာလည်း သေသပ်ကျနစွာ ထုပ်ပိုးပို့ဆောင်ပေးတာမို့ ယုံကြည်စိတ်ချစွာ မှာယူနိုင်ပါတယ်ရှင်။"
    },

    packText: {
        code: "${merchantId}_tmpl_text_34",
        text: "စားဖိုဆောင် မှ ပိုမိုကောင်းမွန်ထူထဲတဲ့ premium quality နဲ့ သေသပ်စွာထုပ်ပိုးပေးထားပါတယ်။ ဒီဇိုင်းအနေအထားပါ ဆန်းသစ်ထားတာမို့ အိမ်သုံးအတွက်လည်း စိတ်ချရ လက်ဆောင်ပေးဖို့၊ လှူဖို့တန်းဖို့ဝယ်ရင်လည်း ပိုပြီး လှပသပ်ရပ်ပါတယ်ရှင့်။"
    },

    noodleText: {
        code: "${merchantId}_tmpl_text_33",
        text: "ကောလင်း ကြက်ဥခေါက်ဆွဲ"
    },

    tea1Text: {
        code: "${merchantId}_tmpl_text_32",
        text: "ရွှေပုစွန်ခြောက် လက်ဖက် (အစိမ့်)"
    },

    oilText: {
        code: "${merchantId}_tmpl_text_31",
        text: "ဓာတုလွတ် နှမ်းဦးရည်ဆီ"
    },

    bagyiText: {
        code: "${merchantId}_tmpl_text_30",
        text: "ဘကြီးဆန်ပြုတ် မူလအရသာ"
    },

    tea2Text: {
        code: "${merchantId}_tmpl_text_29",
        text: "ရွှေပုစွန်ခြောက် လက်ဘက် (ချဉ်စပ်)"
    },

    tea3Text: {
        code: "${merchantId}_tmpl_text_28",
        text: "နမ့်ဆန်လက်ဖက်ခြောက်"
    },

    pdText: {
        code: "${merchantId}_tmpl_text_27",
        text: "စားဖိုဆောင်မှာ ဘာလိုလို... စားဖိုဆောင်ကို သတိရပါ"
    },

    
    cat6Text: {
        code: "${merchantId}_tmpl_text_26",
        text: "သွားရည်စာများ"
    },

    cat5Text: {
        code: "${merchantId}_tmpl_text_25",
        text: "လက်ဖက်စို၊ လက်ဖက်ခြောက်အမျိုးမျိုး"
    },

    cat4Text: {
        code: "${merchantId}_tmpl_text_24",
        text: "ဆန်အမျိုးမျိုး"
    },

    cat3Text: {
        code: "${merchantId}_tmpl_text_23",
        text: "ပဲအမျိုးမျိုးနှင့် ဒေသထွက်ကုန်များ"
    },

    cat2Text: {
        code: "${merchantId}_tmpl_text_22",
        text: "ခွန်အားဖြည့် အစားအသောက်များ"
    },

    cat1Text: {
        code: "${merchantId}_tmpl_text_21",
        text: "ကော်ဖီ နှင့် လက်ဘက်ရည် အမျိုးမျိုး"
    },

    broughtText: {
        code: "${merchantId}_tmpl_text_20",
        text: "စျေးသွားပြီး အလေးအပင်တွေ သယ်စရာမလို ငွေသားထုတ်ပြီး စျေးဝယ်နေစရာမလို . . ."
    },

}